/* global axios */
import ApiClient from './ApiClient';

class CampaignsAPI extends ApiClient {
  constructor() {
    super('campaigns', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  getCampaignStats(campaignId) {
    return axios.get(`${this.url}/${campaignId}/stats`);
  }
}

export default new CampaignsAPI();
